import {
  UPDATE_SESSION
} from '@actions/types';
import {
  getAPIRequest,
  postAPIRequest
} from '@actions';

export const checkAuthorized = () => {
  return (dispatch) => {
    dispatch(
      getAPIRequest(
        '/admin/check_auth',
        {},
        response => {
          dispatch(setLoggedIn(true));
        }
      )
    );
  };
};

export const setLoggedIn = (isLoggedIn) => {
  return (dispatch) => {
    dispatch({ type: UPDATE_SESSION, payload: isLoggedIn });
  };
};

export const submitLogin = (data, onSuccess, onFail) => {
  return (dispatch) => {
    dispatch(
      postAPIRequest(
        '/admin/login',
        data,
        response => {
          dispatch(setLoggedIn(true));
          // to do set props for home page
          onSuccess();
        },
        error => {
          onFail(error.error);
        },
      ),
    );
  };
};

export const logoutUser = (onSuccess, onFail) => {
  return (dispatch) => {
    dispatch(
      postAPIRequest(
        '/admin/logout',
        {},
        response => {
          dispatch({ type: UPDATE_SESSION, payload: false });
          onSuccess();
        },
        error => {
          onFail(error.error);
        },
      ),
    );
  };
};
